import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

// Clip-path curtain reveal + inner parallax scale. Award-style image treatment.
export default function ImageReveal({
  src,
  alt = "",
  className = "",
  imgClassName = "",
  parallax = true,
}) {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const scale = useTransform(scrollYProgress, [0, 1], [1.28, 1.02]);
  const y = useTransform(scrollYProgress, [0, 1], ["-6%", "6%"]);

  return (
    <motion.div
      ref={ref}
      className={`relative overflow-hidden ${className}`}
      initial={{ clipPath: "inset(100% 0% 0% 0%)" }}
      whileInView={{ clipPath: "inset(0% 0% 0% 0%)" }}
      viewport={{ once: true, margin: "-8%" }}
      transition={{ duration: 1.15, ease: [0.16, 1, 0.3, 1] }}
    >
      <motion.img
        src={src}
        alt={alt}
        style={parallax ? { scale, y } : undefined}
        className={`w-full h-full object-cover ${imgClassName}`}
      />
    </motion.div>
  );
}
